import { CubeLoadQuery, readCubeDataRows } from "./cubeQueryTypes";

export const fetchCubeLoad = async (params: {
  cubeLoad: (query: CubeLoadQuery) => Promise<unknown>;
  query: CubeLoadQuery;
}): Promise<unknown> => {
  return params.cubeLoad(params.query);
};

export const getCubeDataOrThrow = (json: unknown): unknown[] => {
  const data = readCubeDataRows(json);
  if (data === undefined) throw new Error("Invalid Cube response: data");
  return data;
};

export const mapCubeLoadFailureToMessage = (err: unknown): string => {
  if (typeof err === "string") return err;
  return "Cube load failed";
};
